import React from 'react';
import { SafeImg } from '../../SafeImg';
import { Btn, H1, Eyebrow, tidFor, E } from './_shared';

/* ════════════════════════════════════════════════════════════════════════
 * STATS — new variants (dark-violet-card · side-stats · stats-with-mockup)
 * Iter 175c — title · tagline · eyebrow · per-stat value+label editable.
 * ════════════════════════════════════════════════════════════════════════ */
export function StatsExt({ block, theme, E: EProps = {} }) {
  const { onEdit } = EProps;
  const c = block.content || {};
  const layout = block.layout;
  const sourceField = Array.isArray(c.stats) ? 'stats' : 'items';
  const stats = c[sourceField] || [];

  if (layout === 'dark-violet-card') {
    const fallback = [{value:'10K',label:'Users'},{value:'95%',label:'Happy'},{value:'24/7',label:'Support'}];
    const list = (stats.length ? stats : fallback).slice(0,3);
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-20" style={{ background: theme.bg }}>
        <div className="max-w-3xl mx-auto rounded-2xl p-10 md:p-16 text-center text-white" style={{ background: '#3B1F8B', borderRadius: theme.radius || 16 }}>
          <E block={block} onEdit={onEdit} field="title" value={c.title || 'A high-quality solution for those who want a beautiful flat startup website quickly.'} tag="h2" className="text-2xl md:text-3xl font-bold leading-tight" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
          <E block={block} onEdit={onEdit} field="tagline" value={c.tagline || ''} tag="p" className="mt-4 text-sm opacity-80" placeholder="Tagline" />
          <div className="mt-10 grid grid-cols-3 gap-4">
            {list.map((s,i)=>(
              <div key={i}>
                <E block={block} onEdit={onEdit} field={`${sourceField}.${i}.value`} value={s.value} tag="p" className="text-3xl font-bold" placeholder="42" />
                <E block={block} onEdit={onEdit} field={`${sourceField}.${i}.label`} value={s.label} tag="p" className="mt-1 text-xs uppercase tracking-wider opacity-80" placeholder="Label" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (layout === 'side-stats') {
    const fallback = [{value:'500',label:'Templates'},{value:'24/7',label:'Updates'}];
    const list = (stats.length ? stats : fallback).slice(0,4);
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="grid grid-cols-1 md:grid-cols-2 min-h-[400px]" style={{ background: theme.bg, color: theme.ink }}>
        <div>{c.image_url ? <SafeImg src={c.image_url} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full bg-gradient-to-br from-gray-300 to-gray-600" />}</div>
        <div className="px-8 md:px-16 py-16 flex flex-col justify-center">
          <E block={block} onEdit={onEdit} field="title" value={c.title || 'Start Your Business'} tag="h2" className="text-3xl md:text-4xl font-bold leading-[1.05] tracking-tight" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
          <E block={block} onEdit={onEdit} field="tagline" value={c.tagline || ''} tag="p" className="mt-4 opacity-70" placeholder="Tagline" />
          <div className="mt-8 grid grid-cols-2 gap-6">
            {list.map((s,i)=>(
              <div key={i}>
                <E block={block} onEdit={onEdit} field={`${sourceField}.${i}.value`} value={s.value} tag="p" className="text-2xl font-bold" style={{ color: theme.accent }} placeholder="42" />
                <E block={block} onEdit={onEdit} field={`${sourceField}.${i}.label`} value={s.label} tag="p" className="text-xs uppercase opacity-70" placeholder="Label" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (layout === 'stats-with-mockup') {
    const fallback = [{value:'10K+',label:'Active Users'},{value:'500M',label:'Requests / day'},{value:'99.9%',label:'Uptime'},{value:'24/7',label:'Support'}];
    const list = (stats.length ? stats : fallback).slice(0,4);
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-20" style={{ background: theme.bg, color: theme.ink }}>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <E block={block} onEdit={onEdit} field="eyebrow" value={c.eyebrow || ''} tag="p" className="text-xs uppercase tracking-[0.22em] opacity-70 mb-3" placeholder="Eyebrow" />
            <E block={block} onEdit={onEdit} field="title" value={c.title || 'Our impact in numbers'} tag="h2" className="text-3xl md:text-4xl font-bold leading-[1.05] tracking-tight" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
            <E block={block} onEdit={onEdit} field="tagline" value={c.tagline || ''} tag="p" className="mt-4 opacity-75" placeholder="Tagline" />
            <div className="mt-8 grid grid-cols-2 gap-6">
              {list.map((s,i)=>(
                <div key={i}>
                  <E block={block} onEdit={onEdit} field={`${sourceField}.${i}.value`} value={s.value} tag="p" className="text-3xl md:text-4xl font-bold" style={{ color: theme.accent, fontFamily: theme.headingFont }} placeholder="42" />
                  <E block={block} onEdit={onEdit} field={`${sourceField}.${i}.label`} value={s.label} tag="p" className="mt-1 text-xs uppercase tracking-wider opacity-70" placeholder="Label" />
                </div>
              ))}
            </div>
          </div>
          <div className="aspect-square">
            {c.image_url ? <SafeImg src={c.image_url} alt="" className="w-full h-full object-contain" /> : (
              <div className="w-full h-full rounded-2xl bg-gradient-to-br from-violet-300 via-fuchsia-400 to-pink-500" />
            )}
          </div>
        </div>
      </section>
    );
  }
  return null;
}
